var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditorBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#8688A5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 17.0248V13H13.4178C14.6078 13 15.8335 13.5619 15.8335 15.0124C15.8335 16.4629 14.2251 17.0248 12.9329 17.0248H9.00001ZM9.00001 7.00001H13.3357C14.3355 7.00001 15.1499 7.88774 15.1499 9.00001C15.1499 9.88974 14.3355 11 13.3357 11H9.00001V7.00001ZM17.192 8.89869C17.192 6.75435 15.4479 5.01019 13.3035 5.01019C13.3035 5.01019 9.33311 5.00024 8.16668 5.00024C7.00024 5.00024 7.00024 6.16668 7.00024 6.16668C7.00024 6.16668 7.00024 16.6664 7.00024 17.8333C7.00024 19.0002 8.16668 19.0002 8.16668 19.0002L13.7387 19.0102C16.072 19.0102 17.9702 17.1494 17.9702 14.8615C17.9702 13.4744 17.2714 12.2435 16.2004 11.4899C16.8164 10.8015 17.192 9.89385 17.192 8.89869Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorBold);
export default __webpack_public_path__ + "static/media/editor-bold.43bc10af.svg";
export { ForwardRef as ReactComponent };